import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=217852fe&scoped=true&"
import script from "./FAQPage.vue?vue&type=script&lang=ts&"
export * from "./FAQPage.vue?vue&type=script&lang=ts&"
import style0 from "./FAQPage.vue?vue&type=style&index=0&id=217852fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217852fe",
  null
  
)

export default component.exports